import { Grid } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'
import { getFirstItem } from 'lib/util'
import AvatarImage from 'ui/Element/Image/Avatar'

const styles = () => ({
  icon: {
    width: '3rem',
    minHeight: '3rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
})

/**
 * Displays the image of a service item.
 *
 * @param {Object} classes  styles for the component
 * @param {Object} props    props for the component
 * @returns {JSX.Element}
 */
const ListItemCellServiceItemImage = (classes, props = {}) => {
  const { product = {} } = props

  const { avatar } = product?.refs || {}
  const avatarRef = getFirstItem(avatar)

  const attachment = avatarRef?.value?.name
    ? { ...avatarRef, api: { api: { ref: 'equipment' } } }
    : { value: { name: '' } }

  return (
    <Grid
      item
      xs={'auto'}
      className={classes.icon}
    >
      <AvatarImage
        shape={'circular'}
        attachment={attachment}
        icon={{
          name: 'device',
          size: '1.5rem',
          color: 'gray.400',
          background: 'gray.960',
        }}
      />
    </Grid>
  )
}

export default CellHOC(ListItemCellServiceItemImage, styles)
